/**
 * Ombraz Product Filter System
 * This script handles the filtering functionality for Ombraz products.
 * It allows users to filter products based on frame styles, gear, frame sizes, and lens options.
 */

let isMobile = window.matchMedia("(max-width: 1199px)").matches;

function initializeFilters() {
  const filterToggle = document.getElementById("ombrazFilterHeader");
  if (filterToggle) {
    filterToggle.addEventListener("click", toggleFilter);
  }

  const filterCheckboxes = document.querySelectorAll(
    '.ombraz-accordion-content input[type="checkbox"]'
  );
  const bestSellerCheckbox = document.querySelector(
    '.ombraz-best-seller input[type="checkbox"]'
  );
  const productItems = document.querySelectorAll(
    ".ombraz-product-v2__grid-item"
  );
  const saleCheckbox = document.querySelector(
    '.ombraz-sale input[type="checkbox"]'
  );

  // Hide both buttons initially
  toggleClearButton(false);
  toggleShowResultsButton(false);

  // Add change event listener to Best Seller checkbox
  if (bestSellerCheckbox) {
    bestSellerCheckbox.addEventListener("change", () => {
      toggleShowResultsButton(bestSellerCheckbox.checked);
      handleBestSellerFilter();

      if (isMobile && bestSellerCheckbox.checked) {
        scrollToShowResults();
      }
    });
  }

  // Add change event listener to Sale checkbox
  if (saleCheckbox) {
    saleCheckbox.addEventListener("change", () => {
      toggleShowResultsButton(saleCheckbox.checked);
      handleSaleFilter();

      if (isMobile && saleCheckbox.checked) {
        scrollToShowResults();
      }
    });
  }

  // Show all products by default
  if (productItems.length) {
    productItems.forEach((item) => item.classList.remove("hide-this"));
  }

  // Add checkbox change event listener
  if (filterCheckboxes.length) {
    filterCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (event) => {
        // Uncheck Best Seller checkbox when any other filter is checked
        const bestSellerCheckbox = document.querySelector(
          '.ombraz-best-seller input[type="checkbox"]'
        );
        const saleCheckbox = document.querySelector(
          '.ombraz-sale input[type="checkbox"]'
        );

        if (saleCheckbox && saleCheckbox.checked) {
          saleCheckbox.checked = false;
          console.log("saleCheckbox", saleCheckbox);
        }

        if (
          bestSellerCheckbox &&
          bestSellerCheckbox.checked &&
          checkbox.checked
        ) {
          bestSellerCheckbox.checked = false;
          const bestSellerProducts = document.querySelector(
            "[data-custom-products]"
          );
          if (bestSellerProducts) {
            bestSellerProducts.classList.add("hide-this");
          }
        }

        // Check if any checkbox is checked
        const hasCheckedBoxes = Array.from(filterCheckboxes).some(
          (cb) => cb.checked
        );

        // Show/hide the buttons based on checked state
        toggleShowResultsButton(hasCheckedBoxes);
        toggleClearButton(hasCheckedBoxes);

        if (!isMobile) {
          applyFilters(event);
        } else if (hasCheckedBoxes) {
          // Scroll to show results button on mobile when checking a filter
          scrollToShowResults();
        }
      });
    });
  }

  const showResultsBtn = document.getElementById("show-results");
  if (showResultsBtn) {
    showResultsBtn.addEventListener("click", () => {
      const bestSellerCheckbox = document.querySelector(
        '.ombraz-best-seller input[type="checkbox"]'
      );

      if (bestSellerCheckbox && bestSellerCheckbox.checked) {
        handleBestSellerFilter();
      } else {
        applyFilters();
      }

      if (isMobile) {
        closeTheFilterHederMobile();
      }
    });
  }

  // Add change event listener to the Best Seller checkbox
  if (bestSellerCheckbox) {
    bestSellerCheckbox.addEventListener("change", handleBestSellerFilter);
  }

  // Initialize the accordion
  initializeAccordion();

  // Handle URL-based filtering
  handleURLBasedFiltering();

  // Clear all filters
  clearAllFilters();
}

function applyFilters(event) {
  // Get the checkbox that triggered the event
  const changedCheckbox = event ? event.target : null;
  const changedFilterType = changedCheckbox
    ? changedCheckbox.getAttribute("data-filter-type")
    : null;

  // Handle Best Seller checkbox differently
  const bestSellerCheckbox = document.querySelector(
    '.ombraz-best-seller input[type="checkbox"]'
  );

  // If the changed checkbox is a gear filter
  if (changedFilterType === "gear") {
    if (changedCheckbox.checked) {
      // Uncheck all non-gear filters
      uncheckFilters("frame-style");
      uncheckFilters("frame-size");
      uncheckLensOptions();
      uncheckFilters("frame-color");
    }
  } else if (changedCheckbox && changedCheckbox.checked) {
    // If the changed checkbox is not a gear filter
    uncheckFilters("gear");
  }

  // Get checked values for each filter type
  const checkedFrameStyles = getCheckedValues("frame-style");
  const checkedGearItems = getCheckedValues("gear");
  const checkedFrameSizes = getCheckedValues("frame-size");
  const checkedLensOptions = getCheckedLensOptions();
  const checkedFrameColors = getCheckedFrameColors();

  const productItems = document.querySelectorAll(
    ".ombraz-product-v2__grid-item"
  );

  let visibleItemCount = 0;
  let visibleItems = [];

  // Check if no filters are selected
  const noFiltersSelected =
    checkedFrameStyles.length === 0 &&
    checkedGearItems.length === 0 &&
    checkedFrameSizes.length === 0 &&
    checkedLensOptions.length === 0 &&
    checkedFrameColors.length === 0;

  // Define the default order for frame styles and lens options
  const defaultFrameOrder = [
    "classic",
    "dolomite",
    "leggero",
    "cammina",
    "viale",
    "teton",
  ];

  const defaultLensOrder = ["polarized", "non-polarized", "blue-blocking"];

  // Apply filters to each product item
  requestAnimationFrame(() => {
    productItems.forEach((item) => {
      const itemStyle = (item.getAttribute("data-style") || "").toLowerCase(); // Get frame style
      const itemGear = (item.getAttribute("data-gear") || "").toLowerCase(); // Get gear type
      const itemSizes = getAvailableSizes(item); // Get available sizes
      const itemLensValue = (
        item.getAttribute("data-lens-value") || ""
      ).toLowerCase(); // Get lens value
      const itemColor = (item.getAttribute("data-color") || "").toLowerCase(); // Get frame color

      const matchesFrameStyle =
        checkedFrameStyles.length === 0 ||
        checkedFrameStyles.includes(itemStyle);
      const matchesGear =
        checkedGearItems.length === 0 || checkedGearItems.includes(itemGear);
      const matchesFrameSize =
        checkedFrameSizes.length === 0 ||
        checkedFrameSizes.some((size) => itemSizes.includes(size));
      const matchesFrameColor =
        checkedFrameColors.length === 0 ||
        checkedFrameColors.includes(itemColor);

      // Update this part to correctly match lens options
      const matchesLensOption =
        checkedLensOptions.length === 0 ||
        checkedLensOptions.some((option) => {
          if (option === "polarized") {
            return (
              itemLensValue.includes("polarized") &&
              !itemLensValue.includes("non-polarized")
            );
          } else if (option === "non-polarized") {
            return itemLensValue.includes("non-polarized");
          } else {
            return itemLensValue.includes(option);
          }
        });

      const isVisible =
        matchesFrameStyle &&
        matchesGear &&
        matchesFrameSize &&
        matchesLensOption &&
        matchesFrameColor; // Ensure frame color matches

      // If no filters are selected, show the products in the specified order
      if (noFiltersSelected) {
        if (defaultFrameOrder.includes(itemStyle)) {
          item.classList.remove("hide-this");
          visibleItems.push(item);
          visibleItemCount++;
        } else {
          item.classList.add("hide-this");
        }
      } else {
        item.classList.toggle("hide-this", !isVisible);
        if (isVisible) {
          visibleItems.push(item);
          visibleItemCount++;
        }
      }
    });

    // Reorder the items, placing the visible ones first and maintaining the default order
    if (noFiltersSelected) {
      const productGrid = document.querySelector(".ombraz-product-v2__grid");
      if (productGrid) {
        defaultFrameOrder.forEach((style) => {
          defaultLensOrder.forEach((lens) => {
            visibleItems
              .filter(
                (item) =>
                  item.getAttribute("data-style").toLowerCase() === style &&
                  item.getAttribute("data-lens-value").toLowerCase() === lens
              )
              .forEach((item) => productGrid.appendChild(item));
          });
        });
      }
    } else {
      const productGrid = document.querySelector(".ombraz-product-v2__grid");
      if (productGrid && visibleItems.length > 0) {
        visibleItems.forEach((item) => {
          productGrid.appendChild(item); // Append each visible item back to the grid
        });
      }
    }

    // Display "No results" message if no items are visible and filters are selected
    displayNoResultsMessage(visibleItemCount === 0 && !noFiltersSelected);

    // Show or hide the "Clear All" button
    toggleClearButton(!noFiltersSelected);

    // Scroll to the first visible card
    scrollToFirstVisibleCard();
  });
}

function uncheckFilters(filterType) {
  const checkboxes = document.querySelectorAll(
    `.ombraz-accordion-content input[type="checkbox"][data-filter-type="${filterType}"]`
  );
  checkboxes.forEach((checkbox) => (checkbox.checked = false));
}

function uncheckLensOptions() {
  const lensOptionCheckboxes = document.querySelectorAll(
    '.ombraz-accordion-content input[type="checkbox"][data-filter-type="lens-option"]'
  );
  lensOptionCheckboxes.forEach((checkbox) => (checkbox.checked = false));
}

function getCheckedValues(filterType) {
  const checkedCheckboxes = document.querySelectorAll(
    `.ombraz-accordion-content input[type="checkbox"][data-filter-type="${filterType}"]:checked`
  );
  return Array.from(checkedCheckboxes).map((cb) =>
    (cb.getAttribute("data-frame-style") || "").toLowerCase()
  );
}

function getAvailableSizes(item) {
  const sizes = [];
  if (item.querySelector('input[id^="regular-"]')) sizes.push("regular");
  if (item.querySelector('input[id^="narrow-"]')) sizes.push("narrow");
  if (item.querySelector('input[id^="xl-"]')) sizes.push("xl");
  return sizes;
}

function displayNoResultsMessage(show) {
  let messageElement = document.getElementById("noResultsMessage");

  if (show && !messageElement) {
    messageElement = document.createElement("div");
    messageElement.id = "noResultsMessage";
    messageElement.textContent = "No products match the selected filters.";
    messageElement.style.textAlign = "center";
    messageElement.style.padding = "2rem";
    messageElement.style.fontSize = "1.8rem";
    messageElement.style.gridColumn = "1/10";

    const productContainer = document.querySelector(".ombraz-product-v2__grid");
    if (productContainer) {
      productContainer.appendChild(messageElement);
    }
  } else if (!show && messageElement) {
    messageElement.remove();
  }
}

function getCheckedLensOptions() {
  const checkedLensOptions = document.querySelectorAll(
    '.ombraz-accordion-content input[type="checkbox"][data-filter-type="lens-option"]:checked'
  );
  return Array.from(checkedLensOptions).map((cb) =>
    (cb.getAttribute("data-lens-option") || "").toLowerCase()
  );
}

function getCheckedFrameColors() {
  const checkedFrameColors = document.querySelectorAll(
    '.ombraz-accordion-content input[type="checkbox"][data-filter-type="frame-color"]:checked'
  );
  return Array.from(checkedFrameColors).map((cb) =>
    (cb.getAttribute("data-frame-color") || "").toLowerCase()
  );
}

function handleURLBasedFiltering() {
  const currentPath = window.location.pathname;

  // Function to handle filter application
  const applyURLFilter = () => {
    if (currentPath.includes("/collections/on-sale")) {
      // Check sale checkbox and apply filter
      const saleCheckbox = document.querySelector(
        '.ombraz-sale input[type="checkbox"]'
      );
      if (saleCheckbox) {
        saleCheckbox.checked = true;
        handleSaleFilter();
      }
    } else if (currentPath.includes("/collections/best-sellers")) {
      setBestSellerFilter();
    } else if (currentPath.includes("/collections/non-polarized")) {
      setFilterOption("lens-option", "non-polarized");
    } else if (currentPath.includes("/collections/polarized")) {
      setFilterOption("lens-option", "polarized");
    } else if (currentPath.includes("/collections/blue-blocker")) {
      setFilterOption("lens-option", "blue-blocking");
    } else if (currentPath.includes("/collections/gear")) {
      const gearSearchParams = new URLSearchParams(window.location.search);
      if (gearSearchParams.has("sideshields")) {
        setFilterOption("gear", "shields");
      } else if (gearSearchParams.has("risers")) {
        setFilterOption("gear", "risers");
      } else {
        setAllGearOptions();
      }
    }

    // Apply filters immediately for mobile
    if (isMobile) {
      applyFilters();
      const hasFilters = document.querySelector(
        '.ombraz-accordion-content input[type="checkbox"]:checked'
      );
      toggleShowResultsButton(!!hasFilters);
    }

    setTimeout(scrollToFilterArea, 300);
  };

  // Handle specific URLs with a delay to ensure DOM is ready
  setTimeout(applyURLFilter, 100);

  // Scroll to first visible card on shop-all page
  if (currentPath.includes("/collections/shop-all")) {
    setTimeout(() => {
      if (!isMobile) {
        scrollToFirstVisibleCard();
      } else {
        scrollToFilterArea();
      }
    }, 300);
  }
}

function setBestSellerFilter() {
  const bestSellerCheckbox = document.querySelector(
    '.ombraz-best-seller input[type="checkbox"]'
  );
  if (bestSellerCheckbox) {
    bestSellerCheckbox.checked = true;
    handleBestSellerFilter();
  }
}

function setFilterOption(filterType, optionValue) {
  const checkbox = document.querySelector(
    `input[type="checkbox"][data-filter-type="${filterType}"][data-${
      filterType === "gear" ? "frame-style" : "lens-option"
    }="${optionValue}"]`
  );
  if (checkbox) {
    const details = checkbox.closest(".ombraz-accordion-item");
    if (details) {
      details.setAttribute("open", "");
      updateAccordionIcon(details, true);
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event("change"));

      // Show buttons on mobile
      if (isMobile) {
        toggleShowResultsButton(true);
        toggleClearButton(true);
      }
    }
  }
}

function setAllGearOptions() {
  const gearCheckboxes = document.querySelectorAll(
    'input[type="checkbox"][data-filter-type="gear"]'
  );
  const gearDetails = gearCheckboxes[0]?.closest(".ombraz-accordion-item");
  if (gearDetails) {
    gearDetails.setAttribute("open", "");
    updateAccordionIcon(gearDetails, true);
    gearCheckboxes.forEach((checkbox) => {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event("change"));
    });

    // Show buttons on mobile
    if (isMobile) {
      toggleShowResultsButton(true);
      toggleClearButton(true);
    }
  }
}

function updateAccordionIcon(accordionItem, isOpen) {
  const icon = accordionItem.querySelector(".ombraz-icon");
  if (icon) {
    if (isOpen) {
      icon.classList.remove("ombraz-icon-plus");
      icon.classList.add("ombraz-icon-minus");
    } else {
      icon.classList.remove("ombraz-icon-minus");
      icon.classList.add("ombraz-icon-plus");
    }
  }
}

function initializeAccordion() {
  const accordionItems = document.querySelectorAll(".ombraz-accordion-item");

  accordionItems.forEach((item) => {
    const summary = item.querySelector("summary");
    const icon = summary?.querySelector(".ombraz-icon");

    if (summary) {
      // Set initial icon state
      if (icon) {
        const isOpen = item.hasAttribute("open");
        icon.classList.toggle("ombraz-icon-minus", isOpen);
        icon.classList.toggle("ombraz-icon-plus", !isOpen);
      }

      summary.addEventListener("click", (e) => {
        e.preventDefault();
        const isOpen = item.hasAttribute("open");

        // Close all other accordion items only on desktop
        if (!isMobile) {
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.hasAttribute("open")) {
              otherItem.removeAttribute("open");
              const otherIcon = otherItem.querySelector(".ombraz-icon");
              if (otherIcon) {
                otherIcon.classList.remove("ombraz-icon-minus");
                otherIcon.classList.add("ombraz-icon-plus");
              }
            }
          });
        }

        // Toggle current accordion
        item.toggleAttribute("open");

        // Update icon
        if (icon) {
          if (!isOpen) {
            icon.classList.remove("ombraz-icon-plus");
            icon.classList.add("ombraz-icon-minus");
          } else {
            icon.classList.remove("ombraz-icon-minus");
            icon.classList.add("ombraz-icon-plus");
          }
        }
      });
    }
  });
}

function clearAllFilters() {
  const clearButtonDesktop = document.getElementById("clear-all");
  const clearButtonMobile = document.getElementById("clear-all-mobile");

  function handleClearAll() {
    const allCheckboxes = document.querySelectorAll(
      '.ombraz-accordion-content input[type="checkbox"]:checked, .ombraz-best-seller input[type="checkbox"]:checked'
    );

    if (allCheckboxes.length) {
      allCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event("change"));
      });
    }

    // Clear Best Seller filter
    const bestSellerCheckbox = document.querySelector(
      '.ombraz-best-seller input[type="checkbox"]'
    );
    if (bestSellerCheckbox && bestSellerCheckbox.checked) {
      bestSellerCheckbox.checked = false;
      handleBestSellerFilter();
    }

    // Hide both buttons
    toggleClearButton(false);
    toggleShowResultsButton(false);

    // Apply filters to reset the view
    applyFilters();

    // Re-apply default filters
    handleURLBasedFiltering();
  }

  // Desktop clear all
  if (clearButtonDesktop) {
    clearButtonDesktop.addEventListener("click", function () {
      handleClearAll();
      if (!isMobile) {
        applyFilters();
      }
    });
  }

  // Mobile clear all
  if (clearButtonMobile) {
    clearButtonMobile.addEventListener("click", function () {
      handleClearAll();
      if (isMobile) {
        applyFilters(); // Reset the view
        closeTheFilterHederMobile();

        // Add delay to ensure DOM updates are complete
        setTimeout(() => {
          const firstVisibleCard = document.querySelector(
            ".ombraz-product-v2__grid-item:not(.hide-this)"
          );
          if (firstVisibleCard) {
            let headerHeight =
              document.querySelector(".ombraz-filter-header")?.offsetHeight ||
              0;

            // Calculate additional offset based on z-index considerations
            const zIndexOffset = 10; // Adjust this value as needed

            const totalOffset = headerHeight + zIndexOffset;

            const targetPosition =
              firstVisibleCard.getBoundingClientRect().top +
              window.scrollY -
              totalOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          }
        }, 100);
      }
    });
  }
}

function handleBestSellerFilter() {
  const bestSellerCheckbox = document.querySelector(
    '.ombraz-best-seller input[type="checkbox"]'
  );
  const bestSellerProducts = document.querySelector("[data-custom-products]");
  const saleCheckbox = document.querySelector(
    '.ombraz-sale input[type="checkbox"]'
  );

  toggleShowResultsButton(bestSellerCheckbox.checked);
  toggleClearButton(bestSellerCheckbox.checked);

  if (bestSellerCheckbox.checked) {
    // Uncheck Sale checkbox when Best Seller is checked
    if (saleCheckbox && saleCheckbox.checked) {
      saleCheckbox.checked = false;
      const saleProducts = document.querySelector("[data-sale-products]");
      if (saleProducts) {
        saleProducts.classList.add("hide-this");
        saleProducts.classList.add("visually-hidden");
      }
    }

    // Uncheck all other filters when Best Seller is checked
    const allOtherCheckboxes = document.querySelectorAll(
      '.ombraz-accordion-content input[type="checkbox"]:checked'
    );
    allOtherCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Show Best Seller products
    if (bestSellerProducts) {
      bestSellerProducts.classList.remove("hide-this");
      if (!window.matchMedia("(max-width: 1199px)").matches) {
        scrollToBestSellerProducts(bestSellerProducts);
      }
    }

    // Hide all other products
    document
      .querySelectorAll(".ombraz-product-v2__grid-item")
      .forEach((product) => {
        product.classList.add("hide-this");
      });
  } else {
    // Hide Best Seller products
    if (bestSellerProducts) {
      bestSellerProducts.classList.add("hide-this");
    }

    // Show all other products
    document
      .querySelectorAll(".ombraz-product-v2__grid-item")
      .forEach((product) => {
        product.classList.remove("hide-this");
      });

    // Only scroll on desktop
    if (!window.matchMedia("(max-width: 1199px)").matches) {
      scrollToFirstVisibleCard();
    }
  }
}

function scrollToFirstVisibleCard() {
  // returning early to prevent scroll to first visible card
  return;
  // Exit early if on mobile
  if (window.matchMedia("(max-width: 1199px)").matches) {
    return;
  }

  const productGrid = document.querySelector(".ombraz-product-v2__grid");
  if (!productGrid) return;

  const visibleCards = productGrid.querySelectorAll(
    ".ombraz-product-v2__grid-item:not(.hide-this)"
  );
  const targetElement =
    visibleCards.length > 0
      ? visibleCards[0]
      : document.getElementById("noResultsMessage") || productGrid;

  if (targetElement) {
    const header = document.querySelector(".ombraz-filter-header");
    const sidebar = document.querySelector(".ombraz-sidebar");

    const headerHeight = header ? header.offsetHeight : 0;
    const sidebarHeight =
      sidebar && window.innerWidth <= 1280 ? sidebar.offsetHeight : 0;

    const extraSpace = 100;
    const offset = headerHeight + sidebarHeight + extraSpace;

    const startPosition = window.scrollY;
    const targetPosition =
      targetElement.getBoundingClientRect().top + startPosition - offset;
    const distance = targetPosition - startPosition;
    const duration = 500;
    let start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);

      window.scrollTo(0, startPosition + distance * easeInOutCubic(percentage));

      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    window.requestAnimationFrame(step);
  }
}

function scrollToBestSellerProducts(bestSellerProducts) {
  // Only scroll on desktop
  if (!window.matchMedia("(max-width: 1199px)").matches && bestSellerProducts) {
    bestSellerProducts.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function toggleShowResultsButton(show) {
  const showResultsBtn = document.getElementById("show-results");
  if (showResultsBtn) {
    showResultsBtn.classList.toggle("hide-this", !show);
  }
}

function scrollToTopMobile() {
  if (window.matchMedia("(max-width: 1199px)").matches) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

function toggleClearButton(show) {
  const clearButtonDesktop = document.getElementById("clear-all");
  const clearButtonMobile = document.getElementById("clear-all-mobile");

  if (clearButtonDesktop) {
    clearButtonDesktop.classList.toggle("hide-this", !show);
  }

  if (clearButtonMobile) {
    clearButtonMobile.classList.toggle("hide-this", !show);
  }
}

function closeTheFilterHederMobile() {
  const sidebar = document.getElementById("ombrazSidebar");
  const filterWrapper = document.getElementById("ombrazFilterWrapper");
  if (sidebar) {
    sidebar.classList.remove("active");
    if (filterWrapper) {
      filterWrapper.classList.remove("is-full-screen");
    }

    // Restore scroll position and unlock body
    const scrollY = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--scroll-position"
      )
    );
    document.body.classList.remove("filter-active");
    document.documentElement.style.removeProperty("--scroll-position");
    window.scrollTo(0, Math.abs(scrollY));
  }
}

function uncheckAllFilters() {
  const allCheckboxes = document.querySelectorAll(
    '.ombraz-accordion-content input[type="checkbox"], .ombraz-best-seller input[type="checkbox"]'
  );
  allCheckboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });
}

function scrollToShowResults() {
  const showResultsBtn = document.getElementById("show-results");
  if (showResultsBtn && !showResultsBtn.classList.contains("hide-this")) {
    showResultsBtn.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function handleSaleFilter() {
  const saleCheckbox = document.querySelector(
    '.ombraz-sale input[type="checkbox"]'
  );
  const saleProducts = document.querySelector("[data-sale-products]");
  const bestSellerCheckbox = document.querySelector(
    '.ombraz-best-seller input[type="checkbox"]'
  );

  toggleShowResultsButton(saleCheckbox.checked);
  toggleClearButton(saleCheckbox.checked);

  if (saleCheckbox.checked) {
    // Uncheck Best Seller checkbox when Sale is checked
    if (bestSellerCheckbox && bestSellerCheckbox.checked) {
      bestSellerCheckbox.checked = false;
      const bestSellerProducts = document.querySelector(
        "[data-custom-products]"
      );
      if (bestSellerProducts) {
        bestSellerProducts.classList.add("hide-this");
      }
    }

    // Uncheck all other filters when Sale is checked
    const allOtherCheckboxes = document.querySelectorAll(
      '.ombraz-accordion-content input[type="checkbox"]:checked'
    );
    allOtherCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Show Sale products
    if (saleProducts) {
      saleProducts.classList.remove("hide-this");
      saleProducts.classList.remove("visually-hidden");
      if (!window.matchMedia("(max-width: 1199px)").matches) {
        scrollToSaleProducts(saleProducts);
      }
    }

    // Hide all other products
    document
      .querySelectorAll(".ombraz-product-v2__grid-item")
      .forEach((product) => {
        product.classList.add("hide-this");
      });
  } else {
    // Hide Sale products
    if (saleProducts) {
      saleProducts.classList.add("hide-this");
      saleProducts.classList.add("visually-hidden");
    }

    // Show regular products
    document
      .querySelectorAll(".ombraz-product-v2__grid-item")
      .forEach((product) => {
        product.classList.remove("hide-this");
      });
  }
}

function scrollToSaleProducts(saleProducts) {
  // Only scroll on desktop
  if (!window.matchMedia("(max-width: 1199px)").matches && saleProducts) {
    saleProducts.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function toggleFilter() {
  const sidebar = document.getElementById("ombrazSidebar");
  const filterWrapper = document.getElementById("ombrazFilterWrapper");

  if (sidebar) {
    const isActive = sidebar.classList.contains("active");

    if (!isActive) {
      // Opening the filter
      sidebar.classList.add("active");
      if (filterWrapper) {
        filterWrapper.classList.add("is-full-screen");
      }

      // Store current scroll position and lock body
      document.documentElement.style.setProperty(
        "--scroll-position",
        `-${window.scrollY}px`
      );
      document.body.classList.add("filter-active");
    } else {
      // Closing the filter
      closeTheFilterHederMobile();
    }
  }
}
